import { render, staticRenderFns } from "./regPassword.vue?vue&type=template&id=1f2f4ae9&scoped=true&"
import script from "./regPassword.vue?vue&type=script&lang=js&"
export * from "./regPassword.vue?vue&type=script&lang=js&"
import style0 from "./regPassword.vue?vue&type=style&index=0&id=1f2f4ae9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2f4ae9",
  null
  
)

export default component.exports